import React, {useState} from 'react';
import {Controller} from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ({
                           dateFormat = "dd/MM/yyyy",
                           locale = "en-GB",
                           showTimeSelect = false,
                           timeFormat = "HH:mm",
                           control,
                           label,
                           placeholder,
                           name,
                           parentClasses,
                           errorMessage,
                         }) {
  return (
    <>
      <div className={`ee-ap-datepicker${parentClasses ? ' ' + parentClasses : ''}`}>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {label}
        </label>
        <Controller
          name={name}
          control={control}
          onChange={([selected]) => selected}
          render={({field: {value, onChange, onBlur}}) => {
            return (
              <div>
                <DatePicker
                  placeholderText={placeholder}
                  onBlur={onBlur}
                  selected={Date.parse(value)}
                  onChange={onChange}
                  dateFormat={dateFormat}
                  locale={locale}
                  timeFormat={timeFormat}
                  format={timeFormat}
                  showTimeSelect={showTimeSelect}
                  time
                  isClearable
                />
                {
                  errorMessage && (
                    <div className="fv-plugins-message-container invalid-feedback">
                      <div>{errorMessage}</div>
                    </div>
                  )
                }
              </div>
            );
          }}
        />
      </div>
    </>
  );
}